export var MASK_ANIMATION_TIME = 200;
export var KEYBOARD_NAMES;
(function (KEYBOARD_NAMES) {
    KEYBOARD_NAMES["ARROW_LEFT"] = "ArrowLeft";
    KEYBOARD_NAMES["ARROW_RIGHT"] = "ArrowRight";
})(KEYBOARD_NAMES || (KEYBOARD_NAMES = {}));
